@for (line of formattedLines; track line + '') { <!-- https://github.com/angular/angular/issues/56471#issuecomment-2486250783 -->
  {{line}}<br>
}
{{ address.countryCode | countryName:'combined' }}
